import { PageLocatorMap } from '../types/PageLocatorMap';

export const previewOfferPage = {
  footer: {
    root: 'preview-offer-page.footer.root',
  },
  form: {
    disclaimer: 'preview-offer-page.form.disclaimer',
    h1: 'preview-offer-page.form.heading1',
    h2: 'preview-offer-page.form.heading2',
    root: 'preview-offer-page.form.root',
    submitButton: 'preview-offer-page.form.submit-button',
  },
  header: {
    root: 'preview-offer-page.header.root',
  },
} as const satisfies PageLocatorMap;
